import { Task } from "./Routine/types";

export const getTaskUpdateInput = (task: Task) => {
  const base = {
    setInstructions: task.instructions,
    setImageIds: task.images.map(({ id }) => id),
    setTitle: task.title,
  };
  return {
    taskId: task.id,
    check:
      task.type === "TaskCheck"
        ? {
            ...base,
            setSentiments: task.sentiments,
          }
        : undefined,
    number:
      task.type === "TaskNumber"
        ? {
            ...base,
            setUnit: task.unit,
          }
        : undefined,
    text: task.type === "TaskText" ? base : undefined,
  };
};
